const PageContent: React.FC = ({ children }) => {
  return (
    <div style={{ padding: '24px 24px', height: '100vw' }}>{children}</div>
  );
};

export default PageContent;
